import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get user dashboard data */
export const getEnterpriseDashboardStats = async ({ queryKey }: any) => {
  const { id } = queryKey[1];
  const res = await get(`/external-api/get_enterprise_dashboard_counts/${id}`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetEnterpriseDashboardStats = (queryParams: any, onSuccess: any, onError: any) => {
  return useQuery(['ent-dashboard-stats', queryParams], getEnterpriseDashboardStats, {
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetEnterpriseDashboardStats;
